/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/* Global */
import * as React from 'react';
import Form from 'apmui/components/form/View';
import RichText from 'apmui/components/markup/RichTextView';
import { ILogonPageModel } from './Model';
import ReCaptcha from './ReCaptcha';

const LOGON_PAGE_FOCUS_SELECTOR =
    ".apmui-content .apmui-button:not([tabindex='-1']), " +
    ".apmui-content .form-input-container input:not([disabled]):not([tabindex='-1']), " +
    ".apmui-content .form-input-container select:not([disabled]):not([tabindex='-1'])";

/* View for Logon Page */
export default class LogonPageView extends React.Component<ILogonPageModel> {
    reCaptchaInput: JSX.Element;

    render() {
        const pageProps = this.props[this.props.pageType];
        if (!pageProps.form) {
            return null;
        }
        /* header text might change? */
        const title = pageProps.form.title;

        let captcha;
        let postHeader;
        if (pageProps.recaptcha) {
            captcha = <ReCaptcha {...pageProps.recaptcha} />;
        } else if (pageProps.challenge && pageProps.challenge.message) {
            postHeader = pageProps.challenge.message;
        } else if (pageProps.retry) {
            postHeader = pageProps.retry.message;
        }

        let original;
        if (pageProps.original && pageProps.form.action) {
            original = (
                <div id="page-logon-original">
                    <a href={pageProps.form.action}>{pageProps.original.logonOriginalUrl}</a>
                </div>
            );
        }

        return (
            <div className="apmui-content">
                <h2>{title}</h2>
                {postHeader && (
                    <div className="page-logon-postheader">
                        <RichText text={postHeader} />
                    </div>
                )}
                <Form {...pageProps.form}>
                    {captcha}
                    {original}
                </Form>
                {pageProps.customMessage && (
                    <div id="page-custom-message">
                        <RichText text={pageProps.customMessage} />
                    </div>
                )}
            </div>
        );
    }

    setFocus() {
        const focus = document.body.querySelector(LOGON_PAGE_FOCUS_SELECTOR);
        if (focus instanceof HTMLElement) {
            focus.focus();
        }
    }

    componentDidMount() {
        this.setFocus();
    }

    componentDidUpdate() {
        if (!document.activeElement || document.activeElement === document.body) {
            this.setFocus();
        }
    }
}
